export default __webpack_public_path__ + "static/media/logo.45780d76.png";